import React, { useEffect, useState } from "react";
import { GetSopModulePayloadType } from "../../../commonTypes/sopModuleTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { CommonHeader, EmptyListPage, ErrorSuccessModal, TableLoader } from "../../../components/commons";
import { SearchIcon } from "../../../components/Icon";
import SopModuleTable from "../../../components/SopModule/SopModuleTable/SopModuleTable";
import { SOP_REPORTS_MODULE_HEADERS } from "../../../constant/tableHeadersConstants/sopModuleHeaderConst";
import { EmptyList } from "../../../assets/images";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { getSopModuleListAction, resetSopModuleError, resetSopModuleListTotal, resetSopModuleListing, resetSopModuleMessage, resetSopModuleStatusCode, resetSopModuleSuccess } from "../../../redux/sopModule";
import { connect } from "react-redux";
import AllClientsSopFilter from "../../../components/AllClientsSop/AllClientSopFilter";
import { ClientListType } from "../../HRMS/AllUserPerformanceEvaluationReport";
import { GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";

 
type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  sopModuleTotalCount: number;
  sopModuleList: any;
  totalClientCount: any;
  dispatchResetSession: () => void;
  dispatchResetSopModuleError: () => void;
  dispatchResetSopModuleSuccess: () => void;
  dispatchResetSopModuleStatusCode: () => void;
  dispatchResetSopModuleListing: () => void;
  dispatchResetSopModuleMessage: () => void;
  dispatchGetSopModuleListAction: (data: GetSopModulePayloadType) => void;
  dispatchResetSopCount: () => void;
  clientDirectoryList: [] | ClientDirectoryListType[];
  clientDirectoryFetching: boolean;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
};
 
const AllClientsSop = ({
  history,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  sopModuleList,
  sopModuleTotalCount,
  totalClientCount,
  dispatchResetSession,
  dispatchResetSopModuleError,
  dispatchResetSopModuleSuccess,
  dispatchResetSopModuleStatusCode,
  dispatchResetSopModuleListing,
  dispatchResetSopModuleMessage,
  dispatchGetSopModuleListAction,
  dispatchResetSopCount,
  dispatchGetClientDirectoryListAction,
  clientDirectoryList,
  clientDirectoryFetching
}: AppProps) => {
  
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [finalListingData, setFinalListingData] = useState<any>([]);
  const [clientOffset, setClientOffset] = useState<number>(0);
  const [finalClientList, setFinalClientList] = useState<ClientListType[] | []>(
    []
  );
  const [clientSelected, setClientSelected] = useState<ClientListType>({
    value: null,
    label: "Select Client...",
  });
  const [filterStartDate, setFilterStartDate] = useState("")
    const [filterEndDate, setFilterEndDate] = useState("")
  const [filter, setFilter] = useState<boolean>(false);
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);
 

 
  useEffect(() => {
    dispatchResetSopModuleListing();
    dispatchResetSopModuleStatusCode();
    dispatchResetSopModuleMessage();
    dispatchResetSopModuleError();
    dispatchResetSopModuleSuccess();
    dispatchResetSopCount();
    window.scroll({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (clientDirectoryList?.length) {
      if (clientOffset <= +totalClientCount) {
        let finalClientData = clientDirectoryList?.map((e: any) => {
          return {
            value: e?.client_code,
            label: `(${e?.client_code}) ${e?.company_name}`,
          };
        });
        if (clientOffset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientDirectoryList]);
 
  useEffect(() => {
    dispatchResetSopModuleMessage();
    dispatchResetSopModuleError();
    dispatchResetSopModuleSuccess();
 
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue,
        clientCode:clientSelected?.value,
        filterStartDate,
        filterEndDate,
        type:"adminReport"
      };
      if (sopModuleTotalCount) {
        if (offset < +sopModuleTotalCount) {
          dispatchGetSopModuleListAction(finalData);
        }
      } else {
        dispatchGetSopModuleListAction(finalData);
      }
    }
  }, [offset]);
 
  useEffect(() => {
    if (sopModuleList?.length === 0) {
      setFinalListingData(sopModuleList);
    } else if (offset > 0 && sopModuleList?.length > 0) {
      setFinalListingData((prv: any) => [...prv, ...sopModuleList]);
    } else {
      setFinalListingData(sopModuleList);
    }
  }, [sopModuleList]);

  useEffect(() => {
    if (token && totalClientCount) {
      if (clientOffset <= +totalClientCount) {
        const finalData = {
          token,
          status: 1,
          offset:clientOffset,
          limit,
          searchValue: text,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [clientOffset]);

  const fetchClientNewData = () => {
    setClientOffset(0)
    if (token) {
      const finalData = {
        token,
        offset:0,
        limit,
        searchValue: text,
        status: 1,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };

  useDebounce(
    () => {
      fetchClientNewData();
    },
    500,
    [text]
  );

  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setClientOffset((prv) => prv + limit);
  };
 
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
 
      if (
        offset < sopModuleTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (sopModuleList?.length > 0) {
          if (!fetching && offset < sopModuleTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
 
 
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [sopModuleList]);
 
  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      }
    },
    500,
    [searchValue]
  );
 
  const fetchNewData = () => {
    const finalData = {
      token,
      offset,
      limit,
      searchValue,
      clientCode:clientSelected?.value,
      filterStartDate,
      filterEndDate,
      type:"adminReport"
    };
    if (token) {
      if (offset === 0) {
        dispatchGetSopModuleListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const onMenuClose = () => setLoadCondition(true);
  const handleFilter = (type?: string) => {
    if (type != "clear") {
      setFilter(true);
    }

    const finalData = {
      token,
      offset,
      limit,
      searchValue,
      clientCode: type != "clear" ? clientSelected?.value : null,
      filterStartDate: type != "clear" ? filterStartDate : "",
      filterEndDate: type != "clear" ? filterEndDate  : "",
      type:"adminReport"
    };
    if (token) {
      if (offset === 0) {
        dispatchGetSopModuleListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };
 
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);
    if (value?.length === 0) {
      const finalData = {
        token,
        offset,
        limit,
        clientCode:clientSelected?.value ,
         filterStartDate,
        filterEndDate,
        type:"adminReport"
      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
  };
 
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSopModuleError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("has been deleted successfully!")) {
      dispatchResetSopModuleSuccess();
      dispatchResetSopModuleListing();
      dispatchResetSopModuleMessage();
 
      window.scroll({
        top: 0,
        left: 0,
      });
      const finalData = {
        token,
        offset,
        limit,
        searchValue,
        clientCode:clientSelected?.value,
         filterStartDate,
        filterEndDate,
        type:"adminReport"
      };
      if (token) {
        if (offset === 0) {
          dispatchGetSopModuleListAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    return false;
  };
 

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader
          title="All Client's SOPs"
        />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">All Client's SOPs List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  sopModuleTotalCount ? sopModuleTotalCount : 0
                } SOPs list found`}</div>
              )}
            </div>
            <div className="right-header">
              <div className="col-md-8 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>

              <AllClientsSopFilter
                  setFilterStartDate={setFilterStartDate}
                  setFilterEndDate={setFilterEndDate}
                  filterStartDate={filterStartDate}
                  filterEndDate={filterEndDate}
                  clientSelected={clientSelected}
                  finalClientList={finalClientList}
                  handleChangeClient={handleChangeClient}
                  checkBottom={checkBottom}
                  clientDirectoryFetching={clientDirectoryFetching}
                  onMenuClose={onMenuClose}
                  setText={setText}
                  setOffset={setClientOffset}
                  loadCondition={loadCondition}
                  setLoadCondition={setLoadCondition}
                  handleFilter={handleFilter}
                  setClientSelected={setClientSelected}
                  filter={filter}
                  setFilter={setFilter}
                />
            </div>
          </div>
          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : sopModuleList?.length > 0 ? (
              <SopModuleTable
                data={finalListingData}
                fetching={fetching}
                tableHeaders={SOP_REPORTS_MODULE_HEADERS}
                history={history}
                offset={offset}
                type="adminReport"
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && sopModuleList?.length === 0 && (
                  <EmptyListPage
                    title="No SOPs List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    
      {handleErrorModal()}
   
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.sopModule.success,
  fetching: state.sopModule.fetching,
  message: state.sopModule.message,
  statusCode: state.sopModule.statusCode,
  error: state.sopModule.error,
  sopModuleList: state.sopModule.sopModuleList,
  sopModuleTotalCount: state.sopModule.sopModuleTotalCount,
  totalClientCount: state.clientDirectory.totalCount,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  clientDirectoryFetching: state.clientDirectory.fetching,
});
 
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSopModuleSuccess: () => dispatch(resetSopModuleSuccess()),
  dispatchResetSopModuleError: () => dispatch(resetSopModuleError()),
  dispatchResetSopModuleMessage: () => dispatch(resetSopModuleMessage()),
  dispatchResetSopModuleStatusCode: () => dispatch(resetSopModuleStatusCode()),
  dispatchResetSopModuleListing: () => dispatch(resetSopModuleListing()),
  dispatchGetSopModuleListAction: (data: GetSopModulePayloadType) =>
    dispatch(getSopModuleListAction(data)),
  dispatchResetSopCount: () => dispatch(resetSopModuleListTotal()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AllClientsSop);
